import * as React from "react";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";

import { getDateTime } from "../../helpers";

const TrainsData = ({ data }) => (
  <TableContainer component={Paper}>
    <Table size="small" aria-label="simple table">
      {/*<Table sx={{ maxWidth: "xs" }} size="small" aria-label="simple table">*/}
      <TableHead>
        <TableRow>
          <TableCell>Время проверки</TableCell>
          <TableCell align="right" sx={{ hyphens: "manual" }}>
            Время отправ&shy;ления поезда
          </TableCell>
          <TableCell align="right" sx={{ hyphens: "manual" }}>
            Коли&shy;чество мест
          </TableCell>
          <TableCell align="right">Цена места</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {data.map(
          (
            {
              time,
              departureTime,
              seats_number: seatsNumber,
              seats_cost: seatsCost,
              is_success: isSuccess,
            },
            index
          ) => (
            <TableRow
              key={index}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                backgroundColor: (theme) =>
                  isSuccess
                    ? theme.palette.success.light
                    : theme.palette.error.main,
              }}
            >
              <TableCell component="th" scope="row">
                {/*{time.toString()}*/}
                {/*{`${time.toDateString()} ${time.toLocaleTimeString()}`}*/}
                {getDateTime(time)}
              </TableCell>
              <TableCell align="right">{departureTime}</TableCell>
              <TableCell align="right">{seatsNumber}</TableCell>
              <TableCell align="right">{seatsCost}</TableCell>
            </TableRow>
          )
        )}
      </TableBody>
    </Table>
  </TableContainer>
);

export default TrainsData;
